import type { ReactNode } from "react";
import { Icon, type IconName } from "../../icons";

export interface AuthHeaderProps {
  title: string;
  lead?: ReactNode;
  icon?: IconName;
  iconTone?: "default" | "success" | "warning";
}

export function AuthHeader({ title, lead, icon, iconTone = "default" }: AuthHeaderProps): React.JSX.Element {
  return (
    <div>
      {icon ? (
        <span className={`nb-auth-icon${iconTone !== "default" ? ` is-${iconTone}` : ""}`} aria-hidden="true">
          <Icon name={icon} />
        </span>
      ) : null}
      <h2>{title}</h2>
      {lead ? <p className="nb-auth-lead">{lead}</p> : null}
    </div>
  );
}
